import { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { getSettings, updateSettings, sendDotDigest } from "@/lib/api";
import { useEffect } from "react";

// Monthly DOT digest recipients + Send Digest Now (moved from Default Rates into Settings → Email).
export default function DotDigestEmailSettings() {
  const [settings, setSettings] = useState(null);
  const [sendingDigest, setSendingDigest] = useState(false);
  const [text, setText] = useState("");
  useEffect(() => { getSettings().then(r => { setSettings(r.data); setText((r.data.dot_digest_recipients || []).join(", ")); }).catch(() => {}); }, []);
  const saveRecipients = async () => {
    const list = text.split(",").map(x => x.trim()).filter(Boolean);
    if (list.join(",") === (settings.dot_digest_recipients || []).join(",")) return;
    try { await updateSettings({ ...settings, dot_digest_recipients: list }); setSettings(prev => ({ ...prev, dot_digest_recipients: list })); toast.success("DOT digest recipients saved"); }
    catch { toast.error("Couldn't save recipients"); }
  };
  const sendDotDigestNow = async () => {
    setSendingDigest(true);
    try {
      const { data } = await sendDotDigest();
      toast[data?.status === "sent" ? "success" : "warning"](data?.status === "sent" ? "DOT digest sent" : `DOT digest not sent (${data?.status || "unknown"})`);
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed to send DOT digest"); }
    finally { setSendingDigest(false); }
  };
  if (!settings) return null;
  return (
    <div className="rounded-lg border border-slate-200 p-3" data-testid="dot-digest-email-settings">
                  <div>
                    <Label className="text-xs">Monthly DOT digest recipients</Label>
                    <p className="text-xs text-slate-500 mb-1.5">Comma-separated emails. Sent on the 1st for the prior month — leave blank to send to all admins.</p>
                    <div className="flex gap-2">
                      <Input
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                        placeholder="manager@company.com, ops@company.com"
                        onBlur={saveRecipients}
                        className="h-9 flex-1"
                        data-testid="input-dot-digest-recipients"
                      />
                      <Button
                        variant="outline" size="sm" className="h-9 whitespace-nowrap"
                        onClick={sendDotDigestNow}
                        disabled={sendingDigest}
                        data-testid="btn-send-dot-digest-now"
                      >
                        <Send className="w-3.5 h-3.5 mr-1.5" />{sendingDigest ? "Sending…" : "Send Digest Now"}
                      </Button>
                    </div>
                  </div>
    </div>
  );
}
